export class DeliveryInstructions {
    instructions: string;
}
